// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2abdca91","453":"38208c36","455":"9bb43282","977":"092a04fd"}[chunkId] + ".chunk.js";
};